/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=5516cc76"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5516cc76&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__